<template>
  <div :class="classes" v-loading="importLoading">
    <pt-page-title title="促销活动详情"></pt-page-title>
    <pt-sub-title title="促销活动信息"></pt-sub-title>
    <table :class="$style['pt-promotion-detail-labels']" v-loading="loading">
      <pt-form-list-item label="活动名称：">
        {{promotionData.name}}
      </pt-form-list-item>
      <pt-form-list-item label="活动类型：">{{promotion_detail.promotionType}}</pt-form-list-item>
      <pt-form-list-item v-if="promotion_detail.businessDepartmentName" label="事业部归属：">{{promotion_detail.businessDepartmentName}}</pt-form-list-item>
      <pt-form-list-item label="发放数量：" v-if="promotionData.promotionType==='COUPONS_PACKAGE'">{{promotion_detail.amount?promotion_detail.amount+'份':''}}
      </pt-form-list-item>
      <pt-form-list-item label="生效时间：">{{promotion_detail.validity_date}}</pt-form-list-item>
      <template v-if="promotion_detail.fullReductionDiscount&&promotion_detail.fullReductionDiscount.openFullReduction">
        <pt-form-list-item label="满减活动类型：">{{promotion_detail.fullReductionDiscount&&promotion_detail.fullReductionDiscount.fullReductionType_show}}
        </pt-form-list-item>
        <pt-form-list-item label="满减活动内容："
                           v-if="promotion_detail.fullReductionDiscount&&promotion_detail.fullReductionDiscount.fullReductions&&promotion_detail.fullReductionDiscount.fullReductions.length">
          <table class="content-table">
            <tr v-for="(item,index) in promotion_detail.fullReductionDiscount.fullReductions" :key="index">
              <td>满{{item.discountCondition_show}}{{fullReductionsText}}</td>
              <td>{{item.discount_show}}折</td>
            </tr>
          </table>
        </pt-form-list-item>
      </template>
      <pt-form-list-item label="促销活动唯一ID：">{{promotion_detail.eventObjectId}}</pt-form-list-item>
      <pt-form-list-item label="分享者：" v-if="is_CASH_BACK">
        <template v-if="promotion_detail.mallUserQueryText">
          {{promotion_detail.mallUserQueryText}}
        </template>
        <!-- <template v-else> -->
        <div :class="$style['select-user-name']" v-if="userInfo&&userInfo.length">
          <span>已选择 {{firstUserName}} {{userInfo.length > 1 ? ('等'  +userInfo.length +'位用户...') : ''}}</span>
          <el-button type="text" @click="viewUser">查看</el-button>
        </div>
        <div :class="$style['select-user-name']" v-if="importedCustomerTotal">
          <span style="color:#000!important">已导入 {{importedCustomerFirstName}}
            {{importedCustomerTotal> 1 ? ('等'  +importedCustomerTotal +'位用户...') : ''}}</span>
          <el-button type="text" @click="viewUserOfImport">查看</el-button>
        </div>
        <!-- </template> -->
      </pt-form-list-item>
      <pt-form-list-item label="奖励金额：" v-if="promotion_detail.reword_money_show">
        {{promotion_detail.reword_money_show}}元
      </pt-form-list-item>
      <pt-form-list-item label="活动状态：">{{promotion_detail.promotionStatus}}</pt-form-list-item>
      <pt-form-list-item label="申请人：" v-if="isShoweEditor"> {{editorInfo.operatorName}}</pt-form-list-item>
      <pt-form-list-item label="审核人：" v-if="isShowAuditor"> {{auditInfo.operatorName}}</pt-form-list-item>
      <pt-form-list-item label="审核时间：" v-if="isShowAuditor"> {{promotion_detail.audit_time}}</pt-form-list-item>
      <pt-form-list-item v-if="promotion_detail.status==='REJECTION'&&promotion_detail.rejectedReason" label="驳回理由:">{{promotion_detail.rejectedReason}}
      </pt-form-list-item>
      <pt-form-list-item label="优惠劵：" v-if="showCoupons">
        <div :class="$style['promotion-coupon-list-div']">
          <wt-table :list="couponsList" class="promotion-coupon-list">
            <template>
              <el-table-column label="优惠劵">
                <template slot-scope="scope">
                  {{scope.row.couponData&&scope.row.couponData.name}}
                </template>
              </el-table-column>
              <el-table-column label="优惠劵内容">
                <template slot-scope="scope">
                  <div>{{scope.row.discount}}</div>
                  <div>满{{scope.row.thresholdOfAmount}}元可使用</div>
                </template>
              </el-table-column>
              <!-- <el-table-column label="剩余库存（张）">
                            <template slot-scope="scope">
                                {{scope.row.surplusAmount}}
                            </template>
                        </el-table-column> -->
              <el-table-column label="赠券张数">
                <template slot-scope="scope">
                  {{scope.row.couponAmount}}
                  <!-- <wt-input v-model="scope.row.couponAmount"></wt-input> -->
                </template>
              </el-table-column>
            </template>
          </wt-table>
        </div>
      </pt-form-list-item>
      <pt-form-list-item label="适用商品：" v-else>
        <promotion-detail-goods :goods-list="goodsList" v-if="isShowGoods" :promotion-data="promotionData" :fullReductionDiscount="fullReductionDiscount">
        </promotion-detail-goods>
      </pt-form-list-item>
      <template v-if="is_CASH_BACK">
        <pt-form-list-item label="购买者返券：" v-if="isShowBuyer">
          <promotion-detail-goods-coupon :goods-list="goodsList" customer-type="buyer"></promotion-detail-goods-coupon>
        </pt-form-list-item>
        <pt-form-list-item label="分享者者返券：" v-if="isShowShower">
          <promotion-detail-goods-coupon :goods-list="goodsList" customer-type="shower"></promotion-detail-goods-coupon>
        </pt-form-list-item>
        <pt-form-list-item label="脐血存储活动设置：" v-if="isShowStore">
          <promotion-detail-goods-store :goods-list="goodsList"></promotion-detail-goods-store>
        </pt-form-list-item>
        <pt-form-list-item label="抽奖活动设置：" v-if="isShowDrow">
          <promotion-detail-goods-drow :goods-list="goodsList"></promotion-detail-goods-drow>
        </pt-form-list-item>
      </template>
    </table>
    <el-dialog :visible="isViewUser" :class="$style['user-dialog']" @close="closeDialog" :title="dialog_title">
      <select-view-user v-if="isViewUser" :isImport="isImport" :userListId="userListId" :pageSize="5" :userIds="userIds"> </select-view-user>
    </el-dialog>
  </div>
</template>

<script>
import { goodsListLabels } from './promotion-detail-options'
import { specificationsData } from '../../pt-promotion-coupon/promotion-option'
import promotionDetailGoods from './promotion-detail-goods'
import promotionDetailGoodsCoupon from './promotion-detail-goods-coupon'
import promotionDetailGoodsStore from './promotion-detail-goods-store'
import promotionDetailGoodsDrow from './promotion-detail-goods-drow'
import selectViewUser from 'cps/customer-manage/select-view-user.vue'
// 组件class前缀
const prefixCls = 'pt-propmotion-detail'

export default {
  name: 'pt-propmotion-detail',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    // s是否显示申请人信息
    isShoweEditor () {
      return this.promotion_detail.status !== 'WAITING_COMMIT'
    },
    // 显示优惠券与否
    showCoupons () {
      return this.promotionData.promotionType === 'COUPONS_PACKAGE' || this.promotionData.promotionType === 'CPS_BIND'
    },
    couponsList () {
      return this.promotionData.promotionType === 'CPS_BIND' ? this.promotion_detail.rewardContent.coupons : this.promotion_detail.couponsPackageData
    },
    // 是否先审核人信息
    isShowAuditor () {
      return this.promotion_detail.status !== 'WAITING_COMMIT' && this.promotion_detail.status !== 'WAITING_AUDIT'
    },
    // 审核人信息
    auditInfo () {
      return this.promotion_detail.auditInfo || {}
    },
    // 申请人信息
    editorInfo () {
      return this.promotion_detail.editorInfo || {}
    },
    // 是否显示商品
    isShowGoods () {
      return this.promotionData.promotionType === 'SNAP_UP' || this.promotionData.promotionType === 'TIME_LIMIT_DISCOUNT' ||
      this.promotionData.promotionType === 'CASH_BACK'
    },
    // 满减显示按件还是钱
    fullReductionsText () {
      return this.promotion_detail.fullReductionDiscount.fullReductionType === 'MONEY' ? '元' : '件（销售单位）'
    },
    // 是否是优惠/返现通用活动
    is_CASH_BACK () {
      return this.promotionData.promotionType === 'CASH_BACK'
    },
    // 是否显示购买者优惠券
    isShowBuyer () {
      let flag = false
      this.goodsList.forEach(item => {
        if (item.buyerCouponsBack && item.buyerCouponsBack.length > 0) {
          flag = true
        }
      })
      return flag
    },
    // 是否显示分享者优惠券
    isShowShower () {
      let flag = false
      this.goodsList.forEach(item => {
        if (item.showerCouponsBack && item.showerCouponsBack.length > 0) {
          flag = true
        }
      })
      return flag
    },
    // 是否显示脐血存储活动设置信息
    isShowStore () {
      let flag = false
      this.goodsList.forEach(item => {
        if (item.bringNewReward) {
          flag = true
        }
      })
      return flag
    },
    // 抽奖活动设置
    isShowDrow () {
      let flag = false
      this.goodsList.forEach(item => {
        if (item.buyerTicketsReward || item.sharerTicketsReward || item.actId) {
          flag = true
        }
      })
      return flag
    },
    userInfo () {
      return this.promotion_detail.userInfo
    },
    //
    firstUserName () {
      let res
      for (let i in this.userInfo) {
        if (this.userInfo[i].fullName) {
          res = this.userInfo[i].fullName
          break
        }
      }
      return res
    },
    fullReductionDiscount () {
      return this.promotionDetail.fullReductionDiscount
    }
  },
  components: {
    promotionDetailGoods,
    promotionDetailGoodsCoupon,
    selectViewUser,
    promotionDetailGoodsStore,
    promotionDetailGoodsDrow
  },
  props: {
    promotionDetail: {
      type: Object,
      default: function () {
        return {}
      }
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      goods_list: [],
      goodsListLabels: goodsListLabels,
      promotion_detail: this.promotionDetail,
      goodsList: [],
      promotionData: {},
      isViewUser: false,
      dialog_title: null,
      isImport: false,
      userListId: null,
      importedCustomerTotal: null,
      importedCustomerFirstName: null,
      importLoading: false,
      userIds: null
    }
  },
  watch: {
    promotionDetail: {
      handler: function (val) {
        this.promotion_detail = val
        this.goods_list = val.detailData
        this.promotionData = val.promotionData || {}
        if (val.mallUserCriteria && val.mallUserCriteria.whiteList && val.mallUserCriteria.whiteList.length) {
          let whiteList = val.mallUserCriteria.whiteList
          whiteList.forEach(item => {
            if (item.ids) {
              this.userIds = item.ids
            }
            if (item.userListId) {
              this.userListId = item.userListId
              this.importedCustomer(item.userListId)
            }
          })
        }
      }
    },
    goods_list: {
      handler: function (val) {
        if (val) {
          this.goodsList = specificationsData(val)
        }
      }
    }
  },
  methods: {
    closeDialog () {
      this.isViewUser = false
    },
    viewUser () {
      this.isImport = false
      this.isViewUser = true
      this.dialog_title = '查看已选择用户'
    },
    viewUserOfImport () {
      this.isImport = true
      this.isViewUser = true
      this.dialog_title = '查看已导入用户'
    },
    // 根据用户导入id，获取导入的用户列表
    importedCustomer (userListId) {
      let data = {
        pageable: {
          page: 0,
          size: 50
        },
        userListId: userListId
      }
      this.importLoading = true
      this.$store.dispatch('importedCustomer', data).then(res => {
        this.importedCustomerTotal = res.totalNumber
        let data = res.data
        for (let i in data) {
          this.importedCustomerFirstName = data[i].name
          break
        }
        this.importLoading = false
      }).catch(err => {
        this.importLoading = false
        this.$message.error(err || '获取导入用户列表失败')
      })
    }
  }
}
</script>

<style module lang="less">
@import "~less/var";
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.select-user-name{
  &>span{
    color: #2D2D2D!important;
  }
}
.user-dialog{
  :global
  .el-dialog{
     width: 70%;
    min-width:1000PX;
    max-width:1200Px;
    }
}
.pt-promotion-detail-labels{
     padding: 0 20px;
    width: 100%;
    display: block;
		:global
    tr{
        // display: flex;
        td{
            &>:first-child{
            color: @mainColor!important;
            }
            line-height: 40px;
        }
		}
		:global
		.content-table{
			tr{
				td{
							color: #000!important;
							padding-bottom:0
					}
			}
		}

}
.promotion-coupon-list-div{
     padding: 20px 40px 30px;
    box-sizing: border-box;
    background: @subTitleBackground;
        :global
    .el-table{
        *{
            background-color: @subTitleBackground;

        }
        table{
            border-bottom:1px solid #C4C8D2;

        }
        tr{
            td{
                border-bottom:1px solid #C4C8D2;
            }
        }
    }
}
</style>
<style lang="less">
// .promotion-coupon-list{
//     tr{
//         display: table-row!important;
//     }
//     tr{
//     td{
//         &>div{
//         color:#606266!important

//         }
//     }
// }
// }
.promotion-coupon-list, .goods-show-list{
        .el-table{
            thead{
                th{
                color: #909399!important
                }
            }
            tr{
        display: table-row!important;
                td{
                    &>div{
                    color:#606266!important

                    }
                }
            }
        }
    }
</style>
